import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Appointments } from '@devexpress/dx-react-scheduler';
import {
  minutesInHour,
  secondsInMinute,
  wholeDayInSeconds,
} from 'helpers/timeConsts';
import largeDurationTypeInHours from 'components/ScheduleCalendar/libComponents/AppointmentContentComponent/consts';
import formatMinutes from 'helpers/formatMinutes';
import getDurationFormat from './getDurationFormat';

interface AppointmentContentProps
  extends Pick<Appointments.AppointmentContentProps, 'data' | 'durationType'> {
  isDraftSchedule?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export default function AppointmentContent({
  data,
  durationType,
  isDraftSchedule = false,
  onClick = undefined,
}: AppointmentContentProps) {
  const { t } = useTranslation();
  const startDate = new Date(data.startDate);
  const endDate = new Date(data.endDate ?? data.startDate);

  const minutesDuration = (data.timeTo - data.timeFrom) / secondsInMinute;

  const isEndDateEqualsMidnight = data.timeTo === wholeDayInSeconds;

  const scheduleHours = {
    start: {
      hour: startDate.getHours(),
      minute: formatMinutes(startDate.getMinutes()),
    },
    end: {
      hour: isEndDateEqualsMidnight ? '24' : endDate.getHours(),
      minute: isEndDateEqualsMidnight
        ? '00'
        : formatMinutes(endDate.getMinutes()),
    },
  };

  return (
    <Stack
      justifyContent="space-between"
      height="100%"
      py={minutesDuration >= minutesInHour * largeDurationTypeInHours ? 2 : 0}
      px={2}
      onClick={onClick}
    >
      <Stack>
        <Typography
          variant="body2"
          fontWeight={700}
          color={isDraftSchedule ? 'primary.dark' : 'main.white'}
        >
          {scheduleHours.start.hour}
          <sup>{scheduleHours.start.minute}</sup>&nbsp;-&nbsp;
          {scheduleHours.end.hour}
          <sup>{scheduleHours.end.minute}</sup>
        </Typography>
      </Stack>
      {durationType === 'long' && (
        <Typography variant="caption" color="primary.lightDark">
          {getDurationFormat(minutesDuration, t)}
        </Typography>
      )}
    </Stack>
  );
}
